webpackJsonp([1],Array(21).concat([
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _products = [{ 'id': 1, 'title': 'iPad 4 Mini', 'price': 500.01, 'inventory': 2 }, { 'id': 2, 'title': 'H&M T-Shirt White', 'price': 10.99, 'inventory': 10 }, { 'id': 3, 'title': 'Charli XCX - Sucker CD', 'price': 19.99, 'inventory': 5 }];

/* harmony default export */ __webpack_exports__["a"] = ({
  getProducts: function getProducts(cb) {
    setTimeout(function () {
      return cb(_products);
    }, 100);
  },
  buyProducts: function buyProducts(products, cb, errorCb) {
    setTimeout(function () {
      Math.random() > 0.5 || navigator.userAgent.indexOf('PhantomJS') > -1 ? cb() : errorCb();
    }, 100);
  }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_CartPage__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_CartPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_CartPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_HomePage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ProductPage__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ProductPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_ProductPage__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_HomePage___default.a
  }, {
    path: '/cart',
    name: 'cart',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_CartPage___default.a
  }, {
    path: '/product/:id',
    name: 'product',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ProductPage___default.a
  }]
}));

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cart__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__budgetdetail__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products__ = __webpack_require__(40);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["e" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["e" /* default */].Store({
  modules: {
    cart: __WEBPACK_IMPORTED_MODULE_2__cart__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_4__products__["a" /* default */],
    budgetdetail: __WEBPACK_IMPORTED_MODULE_3__budgetdetail__["a" /* default */]
  }
}));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);





__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  color: ['#2E3A8C', '#2E3A8C', '#2E3A8C'],
  letterColor: '',
  data: []
};

var actions = {};

var mutations = {
  handleClick: function handleClick(state, payload) {
    console.log(payload.color, payload.id);
    switch (parseInt(payload.color)) {
      case 1:
        state.color[payload.id] = '#2E3A8C';
        state.letterColor = '#ffffff';
        break;
      case 2:
        state.color[payload.id] = '#3b755f';
        state.letterColor = '#ffffff';
        break;
      case 3:
        state.color[payload.id] = '#f2ebdb';
        state.letterColor = '#3b755f';
        break;
      case 4:
        state.color[payload.id] = '#ffffff';
        state.letterColor = '#3b755f';
        break;
      case 5:
        state.color[payload.id] = '#202020';
        state.letterColor = '#ffffff';
        break;
    }
    console.log(payload.id, state.color[payload.id]);
  },
  addData: function addData(state, temp) {
    state.data.push(temp);
    console.log(state.data);
  }
};

var getters = {
  cartCount: function cartCount(state) {
    return state.color;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_shop__ = __webpack_require__(21);



var state = {
  added: [],
  lastCheckout: null
};

var actions = {
  checkout: function checkout(_ref, products) {
    var commit = _ref.commit,
        state = _ref.state;

    var savedCartItems = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.added));
    commit('checkout_request');
    __WEBPACK_IMPORTED_MODULE_1__api_shop__["a" /* default */].buyProducts(products, function () {
      return commit('checkout_successful');
    }, function () {
      return commit('checkout_failure', savedCartItems);
    });
  }
};

var mutations = {
  add_to_cart: function add_to_cart(state, productId) {
    state.lastCheckout = null;
    var record = state.added.find(function (p) {
      return p.id === productId;
    });
    if (!record) {
      state.added.push({
        id: productId,
        quantity: 1
      });
    } else {
      record.quantity++;
    }
  },
  checkout_request: function checkout_request(state) {
    state.added = [];
    state.lastCheckout = null;
  },
  checkout_successful: function checkout_successful(state) {
    state.lastCheckout = 'successful';
  },
  checkout_failure: function checkout_failure(state, savedCartItems) {
    state.added = savedCartItems;
    state.lastCheckout = 'failed';
  }
};

var getters = {
  cartProducts: function cartProducts(state, getters, rootState) {
    return state.added.map(function (_ref2) {
      var id = _ref2.id,
          quantity = _ref2.quantity;

      var product = rootState.products.all.find(function (p) {
        return p.id === id;
      });
      return {
        title: product.title,
        price: product.price,
        id: id,
        quantity: quantity
      };
    });
  },
  cartCount: function cartCount(state) {
    var totalCount = 0;
    state.added.forEach(function (_ref3) {
      var quantity = _ref3.quantity;

      totalCount += quantity;
    });
    return totalCount;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_shop__ = __webpack_require__(21);


var state = {
  all: []
};

var actions = {
  addToCart: function addToCart(_ref, product) {
    var commit = _ref.commit;

    commit('add_to_cart', product.id);
  },
  getAllProducts: function getAllProducts(_ref2) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_shop__["a" /* default */].getProducts(function (products) {
      commit('recieve_products', products);
    });
  }
};

var mutations = {
  recieve_products: function recieve_products(state, products) {
    state.all = products;
  },
  add_to_cart: function add_to_cart(state, productId) {
    state.all.find(function (p) {
      return p.id === productId;
    }).inventory--;
  }
};

var getters = {
  allProducts: function allProducts(state) {
    return state.all;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BodyBudget__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BodyBudget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_BodyBudget__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a,
    BodyBudget: __WEBPACK_IMPORTED_MODULE_1__components_BodyBudget___default.a
  },
  name: 'app'
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BudgetDetail_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BudgetDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BudgetDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_apiData_json__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_apiData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_apiData_json__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getData();
    this.apiData = __WEBPACK_IMPORTED_MODULE_3__api_apiData_json___default.a;
  },
  data: function data() {
    return {
      apiData: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['cartCount'])),
  components: { BudgetDetail: __WEBPACK_IMPORTED_MODULE_2__BudgetDetail_vue___default.a },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getData']), {
    handleCheckboxChange: function handleCheckboxChange(_ref) {
      var id = _ref.id,
          isChecked = _ref.isChecked;

      var itemIndex = this.apiData.findIndex(function (item) {
        return item.id === id;
      });
      if (itemIndex !== -1) {
        this.$set(this.apiData, itemIndex, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.apiData[itemIndex], { isChecked: isChecked }));
      }
    }
  })
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BudgetDetail',
  props: {
    id: Number,
    type: String,
    amount: Number,
    active: Boolean,
    action: String,
    linked: Boolean,
    selectedColor: String
  },
  data: function data() {
    return {
      isChecked: false,
      bgColor: '#2E3A8C',
      subColor: '#ffffff',
      isHovered: false,
      isHovered1: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['color']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['computedColor']), {
    computedClassName: function computedClassName() {
      return 'budget-body-logo' + this.id;
    },
    computedCheckBoxClassName: function computedCheckBoxClassName() {
      return 'ios-toggle-check' + this.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['handleClick']), {
    changeColor: function changeColor(color, id) {
      switch (color) {
        case 1:
          this.bgColor = '#2E3A8C';
          this.subColor = '#ffffff';
          break;
        case 2:
          this.bgColor = '#3b755f';
          this.subColor = '#ffffff';
          break;
        case 3:
          this.bgColor = '#f2ebdb';
          this.subColor = '#3b755f';
          break;
        case 4:
          this.bgColor = '#ffffff';
          this.subColor = '#3b755f';
          break;
        case 5:
          this.bgColor = '#202020';
          this.subColor = '#ffffff';
          break;
      }
      var payload = { 'color': color, 'id': id };
      this.handleClick(payload);
    },
    handleCheckboxChange: function handleCheckboxChange(id) {
      this.$emit('checkbox-change', { id: id, isChecked: this.isChecked });
    },
    showDiv: function showDiv() {
      this.isHovered = true;
    },
    showDiv1: function showDiv1() {
      this.isHovered1 = true;
    },
    hideDiv: function hideDiv() {
      var _this = this;

      setTimeout(function () {
        _this.isHovered = false;
      }, 200);
    },
    hideDiv1: function hideDiv1() {
      this.isHovered1 = false;
    }
  })
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['cartCount']))
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    products: 'cartProducts'
  }), {
    checkoutStatus: function checkoutStatus() {
      return this.$store.state.cart.lastCheckout;
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['checkout']))
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getAllProducts();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['allProducts'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getAllProducts']))
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getAllProducts();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['allProducts']), {
    product: function product() {
      var id = parseInt(this.$route.params.id);
      return this.allProducts.find(function (p) {
        return p.id === id;
      }) || {};
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getAllProducts', 'addToCart']))
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  "data-v-4dd4f9f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, _vm._l((this.apiData), function(item) {
    return _c('BudgetDetail', {
      key: item.id,
      staticClass: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4",
      attrs: {
        "id": item.id,
        "type": item.type,
        "amount": item.amount,
        "actions": item.actions,
        "active": item.active,
        "linked": item.linked,
        "selectedColor": item.selectedColor
      },
      on: {
        "checkbox-change": _vm.handleCheckboxChange
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('header-bar'), _vm._v(" "), _c('BodyBudget')], 1)])
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.products.length),
      expression: "!products.length"
    }]
  }, [_c('i', [_vm._v("Please add some products to cart.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.products.length > 0),
      expression: "products.length > 0"
    }]
  }, [_c('table', {
    staticClass: "checkout-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.products), function(p) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.title))])], 1), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(p.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(p.price * p.quantity))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total"
  }, [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(_vm.total))])])], 2)]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "checkout-button",
    attrs: {
      "disabled": !_vm.products.length
    },
    on: {
      "click": function($event) {
        _vm.checkout(_vm.products)
      }
    }
  }, [_vm._v("Checkout")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkoutStatus),
      expression: "checkoutStatus"
    }]
  }, [_vm._v("Checkout " + _vm._s(_vm.checkoutStatus) + ".")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Per Unit")]), _vm._v(" "), _c('th', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("TOTAL")])])
}]}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-body"
  }, [_c('div', {
    class: _vm.computedClassName,
    style: ({
      'background-color': _vm.bgColor
    })
  }, [_c('div', {
    staticClass: "logo-mark"
  }, [_c('svg', {
    attrs: {
      "id": "greenpark_logo",
      "width": "33",
      "height": "33",
      "viewBox": "0 0 33 33",
      "fill": "green",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    style: ({
      'fill': _vm.subColor
    }),
    attrs: {
      "id": "myPath",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.7594 0.296997C7.85226 0.296997 0.631592 7.51767 0.631592 16.4248C0.631592 25.332 7.85226 32.5526 16.7594 32.5526C25.6666 32.5526 32.8872 25.332 32.8872 16.4248C32.8872 7.51767 25.6666 0.296997 16.7594 0.296997ZM17.7055 27.199C11.0821 27.647 5.98988 15.3899 8.37926 13.009C10.5591 10.837 11.4244 11.6134 11.8337 13.4321C12.0624 14.4477 11.8927 15.6938 11.7398 16.8168C11.6069 17.7927 11.4866 18.6756 11.6515 19.2334C12.0061 20.4331 12.6146 21.3839 13.3152 21.3164C14.0159 21.2489 15.1022 19.3642 12.7643 12.1573C11.0417 6.84704 15.6649 5.01134 16.0884 6.11656C16.2796 6.6155 16.0174 7.43242 15.7094 8.39211C15.3352 9.55832 14.8933 10.9354 15.115 12.2088C15.2964 13.251 15.4695 13.8299 15.6241 14.3469C15.8139 14.9814 15.9758 15.5226 16.0909 16.7129C16.1397 17.2168 16.1162 17.8618 16.0913 18.5473C16.0284 20.2787 15.956 22.2693 17.0136 22.9027C18.4899 23.7869 19.1374 19.4874 17.7159 11.7192C16.4394 4.74359 21.0207 6.89465 21.1415 9.00927C21.2624 11.1239 21.1284 14.3007 20.2738 18.7428C19.4193 23.185 20.0408 23.5508 21.1415 22.4336C22.2423 21.3164 22.3038 20.5267 21.6661 16.1227C21.2314 13.1211 25.9298 11.5922 25.4232 15.5363C24.9132 19.5063 22.6049 26.8676 17.7055 27.199Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "budget-text"
  }, [_c('p', {
    style: ({
      'color': _vm.subColor
    })
  }, [_vm._v("This product " + _vm._s(_vm.action))]), _vm._v(" "), _c('p', {
    style: ({
      'color': _vm.subColor
    })
  }, [_vm._v(_vm._s(_vm.amount) + " " + _vm._s(_vm.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "budget-body-detail"
  }, [_c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Link to Public Profile\n        "), _c('span', [_c('span', {
    on: {
      "mouseover": _vm.showDiv,
      "mouseleave": _vm.hideDiv
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "13",
      "viewBox": "0 0 12 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.5 9.47363H6.5V6.47363H5.5V9.47363ZM6 1.97363C3.24 1.97363 1 4.21363 1 6.97363C1 9.73363 3.24 11.9736 6 11.9736C8.76 11.9736 11 9.73363 11 6.97363C11 4.21363 8.76 1.97363 6 1.97363ZM6 10.9736C3.795 10.9736 2 9.17863 2 6.97363C2 4.76863 3.795 2.97363 6 2.97363C8.205 2.97363 10 4.76863 10 6.97363C10 9.17863 8.205 10.9736 6 10.9736ZM5.5 5.47363H6.5V4.47363H5.5V5.47363Z",
      "fill": "#3B755F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.5 4.47363H6.5V5.47363H5.5V4.47363ZM5.5 6.47363H6.5V9.47363H5.5V6.47363Z",
      "fill": "#3B755F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 1.97363C3.24 1.97363 1 4.21363 1 6.97363C1 9.73363 3.24 11.9736 6 11.9736C8.76 11.9736 11 9.73363 11 6.97363C11 4.21363 8.76 1.97363 6 1.97363ZM6 10.9736C3.795 10.9736 2 9.17863 2 6.97363C2 4.76863 3.795 2.97363 6 2.97363C8.205 2.97363 10 4.76863 10 6.97363C10 9.17863 8.205 10.9736 6 10.9736Z",
      "fill": "#3B755F"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tooltip-header"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHovered || _vm.isHovered1),
      expression: "isHovered || isHovered1"
    }],
    staticClass: "tooltip-body",
    class: {
      active: _vm.isHovered
    },
    on: {
      "mouseover": _vm.showDiv1,
      "mouseleave": _vm.hideDiv1
    }
  }, [_vm._m(0)])])])]), _vm._v(" "), _c('input', {
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Badge color")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "colorbtn1",
    on: {
      "click": function($event) {
        _vm.changeColor(1, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn2",
    on: {
      "click": function($event) {
        _vm.changeColor(2, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn3",
    on: {
      "click": function($event) {
        _vm.changeColor(3, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn4",
    on: {
      "click": function($event) {
        _vm.changeColor(4, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn5",
    on: {
      "click": function($event) {
        _vm.changeColor(5, _vm.id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Activate badge")]), _vm._v(" "), _c('div', {
    staticClass: "ios-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isChecked),
      expression: "isChecked"
    }],
    class: _vm.computedCheckBoxClassName,
    attrs: {
      "type": "checkbox",
      "id": "ios-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : (_vm.isChecked)
    },
    on: {
      "change": function($event) {
        _vm.handleCheckboxChange(_vm.id)
      },
      "__c": function($event) {
        var $$a = _vm.isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ios-toggle"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("\n                This widget links directly to your public profile so that you can easily share your impact with your customers. Turn it off here if you do not want the badge to link to it."), _c('br'), _c('hr', {
    staticStyle: {
      "clear": "both",
      "visibility": "hidden"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltip-link"
  }, [_c('a', [_vm._v("View Public Profile")])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-container"
  }, _vm._l((_vm.allProducts), function(p) {
    return _c('div', {
      staticClass: "product"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("$ " + _vm._s(p.price))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item"
  }, [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("BACK")]), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "inventory"
  }, [_vm._v("In Stock: " + _vm._s(_vm.product.inventory))]), _vm._v(" "), _c('button', {
    staticClass: "add-button",
    attrs: {
      "disabled": !_vm.product.inventory
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.inventory > 0 ? "Add to cart" : "Out Of Stock"))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-links col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
  }, [_c('p', [_vm._v("Per product widgets")])])
}]}

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": 1,
		"type": "plastic bottles",
		"amount": 100,
		"action": "collects",
		"active": true,
		"linked": true,
		"selectedColor": "green"
	},
	{
		"id": 2,
		"type": "trees",
		"amount": 10,
		"action": "plants",
		"active": false,
		"linked": false,
		"selectedColor": "black"
	},
	{
		"id": 3,
		"type": "carbon",
		"amount": 20,
		"action": "offsets",
		"active": false,
		"linked": false,
		"selectedColor": "blue"
	}
];

/***/ })
]),[37]);


// WEBPACK FOOTER //
// static/js/app.3e0e4f3cc8fc6fbb9eae.js